import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NotFoundComponent } from '@modules/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'map',
  },
  {
    loadChildren: () =>
      import('./modules/map/map.module').then((m) => m.MapModule),
    path: 'map',
  },
  {
    loadChildren: () =>
      import('./modules/map/map.module').then((m) => m.MapModule),
    path: 'map/:compositionName',
  },
  {
    loadChildren: () =>
      import('./modules/about/about.module').then((m) => m.AboutModule),
    path: 'about',
  },
  {
    data: { title: 'GLOBAL.MVT' },
    loadComponent: () =>
      import('./modules/playground/playground.component').then(
        (m) => m.PlaygroundComponent,
      ),
    path: 'playground',
  },
  {
    loadChildren: () =>
      import('./modules/profile/profile.module').then((m) => m.ProfileModule),
    path: 'profile',
  },
  {
    loadChildren: () =>
      import('./modules/profile/profile.module').then((m) => m.ProfileModule),
    path: 'my-profile',
  },
  {
    loadChildren: () =>
      import('./modules/my-task/my-task.module').then((m) => m.MyTaskModule),
    path: 'my-tasks',
  },
  {
    loadChildren: () =>
      import('./modules/vote/vote.module').then((m) => m.VoteModule),
    path: 'vote',
  },
  {
    component: NotFoundComponent,
    path: '**',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, {})],
})
export class AppRoutingModule {}
